import React from 'react';
import localizedStr, { EN_US, SupportedLocale } from '../../core/util/localizedStr';
import { PrivacyPolicy, TermsOfService } from '../LegalLinks';

interface Props {
  locale?: SupportedLocale;
}

const TosLinks = ({ locale = EN_US }: Props) => (
  <span>
    {localizedStr[locale].I_HAVE_READ_UNDERSTAND_TOS_PP(
      (tos) => (
        <TermsOfService>{tos}</TermsOfService>
      ),
      (pp) => (
        <PrivacyPolicy>{pp}</PrivacyPolicy>
      )
    )}
  </span>
);

export default TosLinks;
